import "../../../Index.scss";
import "./NoResultFound.scss";

export const NoResultFound = ({searchQuery, searchString}:any) => {
    return (
      <div className="notfound-search">
      <div className="notfound-details">
         <p> Your search - “<strong> {searchString?.length ? searchString : searchQuery} </strong>” - did not match any documents. </p>
        <div>
           <h2 className="notfound-h1"> Suggestions </h2>
           <ul className="notfound-items">
             <li> Make sure that all words are spelled correctly. </li>
             <li> Try different keywords. </li>
             <li> Try more general keywords. </li>
           </ul>
         </div>
       </div>
       <div className="empty-data">
         <div className="empty-data-icon">
          <span className="data-icon-desk"> 
            <img src="https://cdn.taxmann.com/taxmann-images/taxmann-premium/noresultfound-2.png"></img>
          </span>
          <span className="data-icon-mob"> 
            <img src="https://cdn.taxmann.com/taxmann-images/taxmann-premium/noresultfound-2.png"></img>
          </span>
           
          

         </div>

         <div className="empty-data-details">
           <h2 className="empty-data-h1"> Sorry, no results found!  </h2>
           <h2 className="empty-data-text-1"> Please check the spelling or try searching for something else  </h2>


         </div>
       </div>

     </div>
    )
}

export default NoResultFound


 